<template>
    <div class="content-wrap">
  
      <!-- 영업기회ID -->
      <div class="alarm-headline-wrap">
        <div class="alarm-headline">
          <ElLabel name="영업기회ID">
            <template #end="{id}">
              <div class="input-group">
                <ElInput :id="id" ref="salesIdRef" v-model="state.alarmParams.sales_id" readonly/>
              </div>
            </template>
  
          </ElLabel>
        </div>
      </div>
      <SalesModal ref="salesRegModalRef" @return="(r) => getInfo(r)" />
  
  
      <div class="alarm-card mt-3" v-if="state.alarmParams.w_enable_yn">
        <div class="alarm-card-head">Warranty 알람설정</div>
        <div class="row g-0 alarm-card-body">
  
          <div class="col-sm-12 col-lg-6 border-end">
            <div class="alarm-card-stitle">되풀이 방법</div>
            <div class="d-flex align-items-stretch" style="height:14rem;">
  
              <!--되풀이 방법 radio 영역-->
              <div class="alarm-week">
                <div class="form-check py-2" v-for="(item,index) of iterationRadio" :key="index">
                  <ElLabel :name="item.cdNm">
                    <template #start="{id}">
                      <ElRadio
                        v-model="state.alarmParams.w_alarm_prd"
                        :id="id"
                        :value="item.cd"
                        @radioChange="iterationChng('w')"
                      />
                    </template>
                  </ElLabel>
                </div>
              </div>
  
              <div v-if="state.alarmParams.w_alarm_prd === 'D'">
                <div class="p-3">
                </div>
              </div>
  
              <div v-if="state.alarmParams.w_alarm_prd === 'W'">
                <div class="p-3">
                  <div class="form-check form-check-inline pt-3" v-for="(day,index) of dailyCheck" :key="index">
                    <ElLabel :name="day.cdNm">
                      <template #start="{id}">
                        <ElCheckbox
                          v-model="state.alarmParams.w_alarm_week"
                          :id="id"
                          :value="day.cd"
                        />
                      </template>
                    </ElLabel>
                  </div>
                </div>
              </div>
  
              <div v-if="state.alarmParams.w_alarm_prd === 'M'">
                <div class="p-3">
                  <div class="d-flex align-items-center">매
                    <ElInput 
                    :id="id" 
                    v-model="state.alarmParams.w_alarm_cyc" 
                    classNm="form-control form-control-sm w-25 m-1" 
                    :onlyNumber="true"
                    />
                    주마다 다음 요일에 되풀이
                  </div>
                  <div>
  
                    <div class="form-check form-check-inline pt-3" v-for="(day,index) of dailyCheck" :key="index">
                      <ElLabel :name="day.cdNm">
                        <template #start="{id}">
                          <ElCheckbox
                            v-model="state.alarmParams.w_alarm_week"
                            :id="id"
                            :value="day.cd"
                          />
                        </template>
                      </ElLabel>
                    </div>
                    
                  </div>
                </div>
              </div>
              <div v-if="state.alarmParams.w_alarm_prd === 'Y'">
                <div class="p-3">
                  <div class="d-flex align-items-center">매
                    <ElInput 
                    :id="id" 
                    v-model="state.alarmParams.w_alarm_cyc" 
                    classNm="form-control form-control-sm w-25 m-1" 
                    :onlyNumber="true"
                    />
                    년마다
                  </div>
                  <div></div>
                  <DatePicker :frmType="'YMD'" format="yyyy-MM-dd" @return="r => state.alarmParams.w_alarm_year = r"
                    :select-date="state.alarmParams.w_alarm_year" />
                    <div>
                  <!-- <div class="form-check form-check-inline pt-3" v-for="(day,index) of dailyCheck" :key="index">
                    <ElLabel :name="day.cdNm">
                      <template #start="{id}">
                        <ElCheckbox
                          v-model="state.alarmParams.w_alarm_week"
                          :id="id"
                          :value="day.cd"
                        />
                      </template>
                    </ElLabel>
                  </div> -->
                </div>    
                </div>
              </div>
            </div>
          </div>
  
          <div class="col-sm-12 col-lg-6">
            <div class="alarm-card-stitle">되풀이 범위</div>
            <div class="d-flex align-items-stretch" style="height:14rem;">
  
              <div class="alarm-week">
                <div class="mb-3">
                  <ElLabel name="시작">
                    <template #end="{id}">
                      <DatePicker 
                        :id="id"
                        :frmType="'YMD'" 
                        format="yyyy-MM-dd" 
                        @return="r => state.alarmParams.w_start_dt = r"
                        :select-date="state.alarmParams.w_start_dt" 
                      />
                    </template>
                  </ElLabel>
                </div>
              </div>
  
              <div class="p-3">
                <div class="form-check py-2">
                  <ElLabel name="종료 날짜">
                    <template #start="{id}">
                      <ElRadio
                        ref="endDate"
                        v-model="state.alarmParams.w_end_ck"
                        :id="id"
                        value="1"
                        @radioChange="rdoChange('w')"
                      />
                    </template>
                    <template #end="{id}">
                      <DatePicker 
                        :id="id"
                        :frmType="'YMD'" 
                        format="yyyy-MM-dd" 
                        @return="r => state.alarmParams.w_end_dt = r"
                        :select-date="state.alarmParams.w_end_dt" 
                        :disabled="state.alarmParams.w_end_ck !== '1'"
                      />
                    </template>
                  </ElLabel>
  
                  
                
  
                </div>
                <div class="form-check py-2">
  
                  <ElLabel name="다음 되풀이 후 종료됨" classNm="form-check-label">
                    <template #start="{id}">
                      <ElRadio
                        ref="reEnd"
                        v-model="state.alarmParams.w_end_ck"
                        :id="id"
                        value="2"
                        @radioChange="r=>rdoChange('w')"
                      />
                      
                      
                    </template>
                    <template #end>
                      <div class="d-flex">
                        <ElInput :id="id" v-model="state.alarmParams.w_end_cnt" type="number" :onlyNumber="true" classNm="form-control me-1" :disabled="state.alarmParams.w_end_ck !== '2'"/>
                        <span id="" class="form-text">
                          회
                        </span>
                      </div>
                    </template>
                  </ElLabel>
  
                  
                </div>
                <div class="form-check py-2">
  
                  <ElLabel name="종료 날짜 지정하지 않음">
                    <template #start="{id}">
                      <ElRadio
                        ref="noReEnd"
                        v-model="state.alarmParams.w_end_ck"
                        :id="id"
                        value="3"
                        @radioChange="r=>rdoChange('w')"
                      />
                    </template>
                  </ElLabel>
  
                </div>
              </div>
  
            </div>
          </div>
        </div>
        <div class="alarm-card-foot">
          <div>
            <div class="form-check form-switch">
  
              <ElLabel name="Warranty 알람기능 활성화">
                <template #start="{id}">
                  <ElCheckbox
                    v-model="state.alarmParams.w_enable_yn"
                    :id="id"
                  />
                </template>
              </ElLabel>
                
              
            </div>
            
          </div>
          <div>
            <!-- <ElButton type="search" @buttonClick="fnItemValidation()">수정</ElButton> -->
            <!-- <ElButton type="search" @buttonClick="$router.push('/sm/MSM_SA_002')"> 이전</ElButton> -->
          </div>
        </div>
      </div>
  
      <div class="alarm-card mt-3" v-else>
        <div class="alarm-card-head">지급일 알람설정</div>
        <div class="row g-0 alarm-card-body">
  
          <div class="col-sm-12 col-lg-6 border-end">
            <div class="alarm-card-stitle">되풀이 방법</div>
            <div class="d-flex align-items-stretch" style="height:14rem;">
  
              <div class="alarm-week">
                <div class="form-check py-2" v-for="(item,index) of iterationRadio" :key="index">
                  <ElLabel :name="item.cdNm">
                    <template #start="{id}">
                      <ElRadio
                        v-model="state.alarmParams.p_alarm_prd"
                        :id="id"
                        :value="item.cd"
                        @radioChange="iterationChng('p')"
                      />
                    </template>
                  </ElLabel>
                </div>
              </div>
  
              <div v-if="state.alarmParams.p_alarm_prd === 'D'">
                <div class="p-3">
                </div>
              </div>
  
              <div v-if="state.alarmParams.p_alarm_prd === 'W'">
                <div class="p-3">
                  <div class="form-check form-check-inline pt-3" v-for="(day,index) of dailyCheck" :key="index">
                    <ElLabel :name="day.cdNm">
                      <template #start="{id}">
                        <ElCheckbox
                          v-model="state.alarmParams.p_alarm_week"
                          :id="id"
                          :value="day.cd"
                        />
                      </template>
                    </ElLabel>
                  </div>
                </div>
              </div>
  
              <div v-if="state.alarmParams.p_alarm_prd === 'M'">
                <div class="p-3">
                  <div class="d-flex align-items-center">매
                    <ElInput :id="id" v-model="state.alarmParams.p_alarm_cyc" classNm="form-control form-control-sm w-25 m-1"/>
                    주마다 다음 요일에 되풀이
                  </div>
                  <div>
  
                    <div class="form-check form-check-inline pt-3" v-for="(day,index) of dailyCheck" :key="index">
                      <ElLabel :name="day.cdNm">
                        <template #start="{id}">
                          <ElCheckbox
                            v-model="state.alarmParams.p_alarm_week"
                            :id="id"
                            :value="day.cd"
                          />
                        </template>
                      </ElLabel>
                    </div>
  
                  </div>
                </div>
              </div>
              <div v-if="state.alarmParams.p_alarm_prd === 'Y'">
                <div class="p-3">
                  <div class="d-flex align-items-center">매
                    <ElInput 
                    :id="id" 
                    v-model="state.alarmParams.p_alarm_cyc" 
                    classNm="form-control form-control-sm w-25 m-1" 
                    :onlyNumber="true"
                    />
                    년마다
                  </div>
                  <DatePicker :frmType="'YMD'" format="yyyy-MM-dd" @return="r => state.alarmParams.p_alarm_year = r"
                    :select-date="state.alarmParams.p_alarm_year" />
                </div>
              </div>
            </div>
          </div>
  
          <div class="col-sm-12 col-lg-6">
            <div class="alarm-card-stitle">되풀이 범위</div>
            <div class="d-flex align-items-stretch" style="height:14rem;">
  
              <div class="alarm-week">
                <div class="mb-3">
                  <ElLabel name="시작">
                    <template #end="{id}">
                      <DatePicker 
                        :id="id"
                        :frmType="'YMD'" 
                        format="yyyy-MM-dd" 
                        @return="r => state.alarmParams.p_start_dt = r"
                        :selectDate="state.alarmParams.p_start_dt" 
                      />
                    </template>
                  </ElLabel>
                  
                </div>
              </div>
              <div class="p-3">
                <div class="form-check py-2 pe-2">
                  <ElLabel name="종료 날짜">
                    <template #start="{id}">
                      <ElRadio
                        ref="endDate"
                        v-model="state.alarmParams.p_end_ck"
                        value="1"
                        @radioChange="r=>rdoChange('p')"
                      />
                    </template>
                    <template #end="{id}">
                      <DatePicker 
                        :id="id"
                        :frmType="'YMD'" 
                        format="yyyy-MM-dd" 
                        @return="r => state.alarmParams.p_end_dt = r"
                        :selectDate="state.alarmParams.p_end_dt"
                        :disabled="state.alarmParams.p_end_ck !== '1'"
                      />
                    </template>
                  </ElLabel>
                </div>
                <div class="form-check py-2">
  
                  <ElLabel name="다음 되풀이 후 종료됨">
                    <template #start="{id}">
                      <ElRadio
                        ref="reEnd"
                        v-model="state.alarmParams.p_end_ck"
                        value="2"
                        @radioChange="r=>rdoChange('p')"
                      />
                    </template>
                    <template #end="{id}">
                      <div class="d-flex">
                        <ElInput :id="id" v-model="state.alarmParams.p_end_cnt" type="number" :onlyNumber="true" classNm="form-control me-1" :disabled="state.alarmParams.p_end_ck !== '2'"/>
                        <span class="form-text">
                          회
                        </span>
                      </div>
                    </template>
                  </ElLabel>
  
                </div>
                <div class="form-check py-2">
  
                  <ElLabel name="종료 날짜 지정하지 않음">
                    <template #start="{id}">
                      <ElRadio
                        :id="id"
                        ref="reEnd"
                        v-model="state.alarmParams.p_end_ck"
                        value="3"
                        @radioChange="r=>rdoChange('p')"
                      />
                    </template>
                  </ElLabel>
  
  
                </div>
              </div>
  
            </div>
          </div>
        </div>
        <div class="alarm-card-foot">
          <div>
            <div class="form-check form-switch">
              <ElLabel name="지급일 알람설정 활성화">
                  <template #start="{id}">
                    <ElCheckbox
                      :id="id"
                      ref="reEnd"
                      v-model="state.alarmParams.p_enable_yn"
                    />
                  </template>
                </ElLabel>
  
            </div>
          </div>
          <div>
            <!-- <ElButton type="search" @buttonClick="fnItemValidation()">수정</ElButton> -->
            <!-- <ElButton type="search" @buttonClick="$router.push('/sm/MSM_SA_002')"> 이전</ElButton> -->
          </div>
        </div>
      </div>
    </div>
  </template>
  
<script setup>

import { reactive, onMounted, onBeforeMount, ref, computed } from 'vue';
import routerCmn from '@/js/vueRouterCmn';
import { useRouter } from "vue-router";
import common from '@/js/common';
import DatePicker from '@/components/common/DatePicker.vue';
import SalesModal from "@/components/common/modal/SalesModal.vue";
import { useCodeStore } from '@/store/code'
const codeStore = useCodeStore()

import { useLoading } from '@/composable/Loading.js'
const { setIsLoading } = useLoading()
import { alarmSelect, alarmEdit } from '@/api/alarm';
import { salesOptyList } from '@/api/sales';

const salesIdRef = ref();
const router = useRouter();
const salesRegModalRef = ref();
// const pageThree = ref();

// 기간설정 초기화 중 DatePicker에서 한달 후 값으로 입력받아 넣으니 달을 바꿔도 무조건 
// 그 다음달로 초기화 되어 end_dt에 대해서만 적용해 주기 위해 아래 값으로 대체함.
var dt = new Date()
var dtStr = dt.getFullYear() + '-' + ('0' + (dt.getMonth() + 1)).slice(-2) + '-' + dt.getDate();




onMounted(() => {
  // state.alarmParams.w_end_dt = dtStr;
  // state.alarmParams.p_end_dt = dtStr;
})

onBeforeMount(async () => {
  const sparam  = history.state.alarm_seq;
  state.alarmParams.alarm_seq = sparam;
  if (state.alarmParams.alarm_seq) {

    let param = {
      alarm_seq: state.alarmParams.alarm_seq
    }
    try {
      setIsLoading(true)
      const res = await alarmSelect(param)
      if(res){
        state.pageType = 'update'
        let detailCp = res.rtn
        if(Object.keys(detailCp).length <= 0){
          alert("조회 데이터가 없습니다. 확인해주세요 ")
          routerCmn.routerPush('/sm/MSM_SA_002')
          return
        }
        state.alarmParams.alarm_seq = detailCp.alarm_seq
        state.alarmParams.sales_id = detailCp.sales_id
        state.alarmParams.w_alarm_cyc = detailCp.w_alarm_cyc
        state.alarmParams.w_alarm_prd = detailCp.w_alarm_prd
        if(detailCp.w_alarm_week){
          let alarmWeek = [...detailCp.w_alarm_week.replaceAll('0','')]

          for (let item of alarmWeek) {
            state.alarmParams.w_alarm_week.push(item)
          }
        }

        state.alarmParams.w_enable_yn = detailCp.w_enable_yn === 'Y';
        state.alarmParams.p_enable_yn = detailCp.p_enable_yn === 'Y';


        state.alarmParams.w_start_dt = detailCp.fmt_w_start_dt || null
        state.alarmParams.w_end_dt = detailCp.fmt_w_end_dt || null
        state.alarmParams.w_snd_cnt = detailCp.w_snd_cnt || 0
        state.alarmParams.w_snd_dt = detailCp.fmt_w_snd_dt || null
        state.alarmParams.w_alarm_year = detailCp.fmt_w_alarm_year || null
        state.alarmParams.w_end_ck = detailCp.w_end_ck

        state.alarmParams.p_alarm_cyc = detailCp.p_alarm_cyc
        state.alarmParams.p_alarm_prd = detailCp.p_alarm_prd

        if(detailCp.p_alarm_week){
          let alarmWeek = [...detailCp.p_alarm_week.replaceAll('0','')]

          for (let item of alarmWeek) {
            state.alarmParams.p_alarm_week.push(item)
          }
        }

        state.alarmParams.p_start_dt = detailCp.fmt_p_start_dt || null
        state.alarmParams.p_end_dt = detailCp.fmt_p_end_dt || null
        state.alarmParams.p_end_cnt = detailCp.p_end_cnt || 0
        state.alarmParams.p_snd_cnt = detailCp.p_snd_cnt || 0
        state.alarmParams.p_snd_dt = detailCp.fmt_p_snd_dt || null
        state.alarmParams.p_alarm_year = detailCp.fmt_p_alarm_year || null
        state.alarmParams.p_end_ck = detailCp.p_end_ck

        state.dupCheck = true

        Object.keys(state.alarmParams).forEach((key)=>{
          if(key.includes('_dt')){
            state.alarmParams[key] = state.alarmParams[key] === '1900-01-01' ? null : state.alarmParams[key]
          }
        })
      }
      

    } catch (err) {
      console.log('영업기회 알람 등록 api 에러', err)
      routerCmn.routerPush('/sm/MSM_SA_002')
    } finally {
      setIsLoading(false)
    }
  }else{
    alert('잘못된 접근입니다.')
    router.back()
  }
})

const iterationRadio = ref([
  {cd : 'D', cdNm : '매일'},
  {cd : 'W', cdNm : '매주'},
  {cd : 'M', cdNm : '매월'},
  {cd : 'Y', cdNm : '매년'},
])

const dailyCheck = ref([
  {cd : 'A', cdNm : '월요일'},
  {cd : 'B', cdNm : '화요일'},
  {cd : 'C', cdNm : '수요일'},
  {cd : 'D', cdNm : '목요일'},
  {cd : 'E', cdNm : '금요일'},
])

const state = reactive({
  AAA : 'AW',
  BBB : 'AP',
  alarmParams: {
    alarm_seq: '',
    sales_id: '',
    w_alarm_cyc: '',
    w_alarm_prd: 'D',
    w_alarm_week: [],
    w_alarm_year: '',
    w_enable_yn: true,
    w_start_dt: '',
    w_end_dt: '',
    w_end_cnt: 0,
    w_snd_cnt: 0,
    w_snd_dt: null,
    w_end_ck: '1',
    p_alarm_cyc: 0,
    p_alarm_prd: 'D',
    p_alarm_week: [],
    p_alarm_year: '',
    p_enable_yn: true,
    p_start_dt: '',
    p_end_dt: '',
    p_end_cnt: 0,
    p_snd_cnt: 0,
    p_snd_dt: null,
    p_end_ck: '1',
    upd_id: ''
  },
  pageType: 'insert'

});

const CheckNumber = (data) => {
  if (data) {
    data = common.checkOnlyNumber(data);
  }
}


const openModal = async (modal) => {
  if (modal == "upload") {
    try {
      let params = {
        page_count: 1,
        unit_count: 100000,
      };
      const res = await salesOptyList(params)
      state.excelModalData = res.rtn;
    } catch (err) {
      console.log("api error", err);
      alert("영업ID 조회 실패");
    }
  } else if ((modal = "salesReg")) {
    salesRegModalRef.value.openModal();
  }
};

//모달에서 값 받아오기
const getInfo = (r) => {
  state.alarmParams.sales_id = r.sales_id;
};

const fnItemValidation = () => {
  let msg = codeStore.getCodeMsg('77777'); // 해당 항목은 필수 입력값입니다.

  if (!state.alarmParams.sales_id) {  // to executes a event not null condition
    alert(msg)
    salesIdRef.value.input.focus()
    return false;
  }
  
  //warranty 알림 활성화 일때 필수값 체크
  if(state.alarmParams.w_enable_yn){

    if(state.alarmParams.w_alarm_prd === 'M'){
      let wAlarmCyc = Number(state.alarmParams.w_alarm_cyc)
      if(wAlarmCyc < 1 || wAlarmCyc > 6){
        alert('주 단위 알람 주기는 1~6이내에 입력해주세요.')
        return
      }
    }

    if(state.alarmParams.w_alarm_prd === 'M' || state.alarmParams.w_alarm_prd === 'W'){
      if(state.alarmParams.w_alarm_week.length <= 0){
        alert('Warranty 알람의 반복요일을 선택해주세요.')
        return
      }
    }

    if(state.alarmParams.w_alarm_prd === 'Y'){
      if(!state.alarmParams.w_alarm_year){
        alert('Warranty 알람의 되풀이 일자를 선택해주세요.')
        return
      }
    }

    
    if(!state.alarmParams.w_start_dt){
      alert('Warranty 알람설정의 시작 날짜를 입력해주세요')
      return
    }
    
    if(state.alarmParams.w_end_ck === '1' && !state.alarmParams.w_end_dt){
      alert('Warranty 알람설정의 종료 날짜를 입력해주세요')
      return
    }

    if(state.alarmParams.w_end_ck === '1' && (state.alarmParams.w_end_dt < state.alarmParams.w_start_dt)){
      alert('Warranty 알람설정의 종료 날짜가 시작날짜보다 빠를 수 없습니다.')
      return
    }
    if(state.alarmParams.w_end_ck === '2' && !state.alarmParams.w_end_cnt){
      alert('Warranty 알람설정의 되풀이 횟수를 입력해주세요')
      return
    }
  }

  //지급일 알림 활성화 일때 필수값 체크
  if(state.alarmParams.p_enable_yn){

    if(state.alarmParams.p_alarm_prd === 'M'){
      let pAlarmCyc = Number(state.alarmParams.p_alarm_cyc)
      if(pAlarmCyc < 1 || pAlarmCyc > 10){
        alert('주 단위 알람 주기는 1~6이내에 입력해주세요.')
        return
      }
    }

    if(state.alarmParams.p_alarm_prd === 'M' || state.alarmParams.p_alarm_prd === 'W'){
      if(state.alarmParams.p_alarm_week.length <= 0){
        alert('지급일 알람의 반복요일을 선택해주세요.')
        return
      }
    }

    if(state.alarmParams.p_alarm_prd === 'Y'){
      if(!state.alarmParams.p_alarm_year){
        alert('지급일의 알람 되풀이 일자를 선택해주세요.')
        return
      }
    }


    if(!state.alarmParams.p_start_dt){
      alert('지급일 알람설정의 시작 날짜를 입력해주세요')
      return
    }
    if(state.alarmParams.p_end_ck === '1' && !state.alarmParams.p_end_dt){
      alert('지급일 알람설정의 종료 날짜를 입력해주세요')
      return
    }

    if(state.alarmParams.p_end_ck === '1' && (state.alarmParams.p_end_dt < state.alarmParams.p_start_dt)){
      alert('지급일 알람설정의 종료 날짜가 시작날짜보다 빠를 수 없습니다.')
      return
    }


    if(state.alarmParams.p_end_ck === '2' && !state.alarmParams.p_end_cnt){
      alert('지급일 알람설정의 되풀이 횟수를 입력해주세요')
      return
    }
  }
  

  RegClick();

}


const rdoChange = (type) => {
  if(type === 'w'){
    // Warranty 종료날짜 선택
    if (state.alarmParams.w_end_ck === '1') {
      state.alarmParams.w_end_cnt = 0
    }
    // Warranty 다음 되풀이 후 종료됨 선택
    else if (state.alarmParams.w_end_ck === '2') {
      state.alarmParams.w_end_dt = ''
    }
    // Warranty 종료날짜 지정하지 않음 선택
    else if (state.alarmParams.w_end_ck === '3') {
      state.alarmParams.w_end_cnt = 0
      state.alarmParams.w_end_dt = ''
    }
  }else{
    // 지급일 종료날짜 선택 
    if (state.alarmParams.p_end_ck === '1') {
      state.alarmParams.p_end_cnt = 0
    }
    // 지급일 다음 되풀이 후 종료됨 선택
    else if (state.alarmParams.p_end_ck === '2') {
      state.alarmParams.p_end_dt = ''
    }
    // 지급일 종료날짜 지정하지 않음 선택
    else if (state.alarmParams.p_end_ck === '3') {
      state.alarmParams.p_end_dt = ''
      state.alarmParams.p_end_cnt = 0
    }
  }

  


}


const ConvertWeek = (getWeek) => {

  var test = getWeek.replace('[', '').replace(']', '').replaceAll('"', '').replaceAll(',', '');
  var str = '';

  if (state.alarmParams.w_alarm_prd == "W" || state.alarmParams.w_alarm_prd == "M") {
    if (test.indexOf('A') == -1) { str += '0' } else { str += 'A' }
    if (test.indexOf('B') == -1) { str += '0' } else { str += 'B' }
    if (test.indexOf('C') == -1) { str += '0' } else { str += 'C' }
    if (test.indexOf('D') == -1) { str += '0' } else { str += 'D' }
    if (test.indexOf('E') == -1) { str += '0' } else { str += 'E' }
  }

  return str;
}


const RegClick = async () => {
  if (confirm("수정 하시겠습니까?")) {
  // 등록, 수정 처리
  try {
    setIsLoading(true)
    let alarmParams = {...state.alarmParams}
    alarmParams.w_alarm_week = ConvertWeek(JSON.stringify(state.alarmParams.w_alarm_week));
    alarmParams.p_alarm_week = ConvertWeek(JSON.stringify(state.alarmParams.p_alarm_week));


    alarmParams.w_enable_yn = alarmParams.w_enable_yn ? 'Y' : 'N'

    alarmParams.p_enable_yn = alarmParams.p_enable_yn ? 'Y' : 'N'
    alarmParams.p_snd_cnt = isNaN(Number(alarmParams.p_snd_cnt)) ? 0 : Number(alarmParams.p_snd_cnt)
    
    Object.keys(alarmParams).forEach((key)=>{
      if(key.includes('_dt')){
        alarmParams[key] = alarmParams[key] || null
      }
    })
    const res = await alarmEdit(alarmParams)
    alert("수정을 완료했습니다.");
    router.push({ name: 'MSM_SA_002' })
  } catch (err) {
    alert("전송 중 에러가 발생하였습니다.");
  } finally {
    setIsLoading(false)
  }
  } // The end of if statement block


}

//되풀이 방법 변경시 값 초기화
function iterationChng(type){
  state.alarmParams[`${type}_alarm_week`] = []
  state.alarmParams[`${type}_alarm_cyc`] = ''
  state.alarmParams[`${type}_alarm_year`] = null
}
</script>